import _slicedToArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { struct, u8 } from '@solana/buffer-layout';
import { publicKey } from '@solana/buffer-layout-utils';
import { TransactionInstruction } from '@solana/web3.js';
import { TOKEN_PROGRAM_ID } from '../constants.js';
import { TokenInvalidInstructionDataError, TokenInvalidInstructionKeysError, TokenInvalidInstructionProgramError, TokenInvalidInstructionTypeError } from '../errors.js';
import { TokenInstruction } from './types.js';
import { COptionPublicKeyLayout } from '../serialization.js';
/** TODO: docs */

export var initializeMint2InstructionData = struct([u8('instruction'), u8('decimals'), publicKey('mintAuthority'), new COptionPublicKeyLayout('freezeAuthority')]);
/**
 * Construct an InitializeMint2 instruction
 *
 * @param mint            Token mint account
 * @param decimals        Number of decimals in token account amounts
 * @param mintAuthority   Minting authority
 * @param freezeAuthority Optional authority that can freeze token accounts
 * @param programId       SPL Token program account
 *
 * @return Instruction to add to a transaction
 */

export function createInitializeMint2Instruction(mint, decimals, mintAuthority, freezeAuthority) {
  var programId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : TOKEN_PROGRAM_ID;
  var keys = [{
    pubkey: mint,
    isSigner: false,
    isWritable: true
  }];
  var data = Buffer.alloc(initializeMint2InstructionData.span);
  initializeMint2InstructionData.encode({
    instruction: TokenInstruction.InitializeMint2,
    decimals: decimals,
    mintAuthority: mintAuthority,
    freezeAuthority: freezeAuthority
  }, data);
  return new TransactionInstruction({
    keys: keys,
    programId: programId,
    data: data
  });
}
/**
 * Decode an InitializeMint2 instruction and validate it
 *
 * @param instruction Transaction instruction to decode
 * @param programId   SPL Token program account
 *
 * @return Decoded, valid instruction
 */

export function decodeInitializeMint2Instruction(instruction) {
  var programId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TOKEN_PROGRAM_ID;
  if (!instruction.programId.equals(programId)) throw new TokenInvalidInstructionProgramError();
  if (instruction.data.length !== initializeMint2InstructionData.span) throw new TokenInvalidInstructionDataError();

  var _decodeInitializeMint = decodeInitializeMint2InstructionUnchecked(instruction),
      mint = _decodeInitializeMint.keys.mint,
      data = _decodeInitializeMint.data;

  if (data.instruction !== TokenInstruction.InitializeMint2) throw new TokenInvalidInstructionTypeError();
  if (!mint) throw new TokenInvalidInstructionKeysError();
  return {
    programId: programId,
    keys: {
      mint: mint
    },
    data: data
  };
}
/**
 * Decode an InitializeMint2 instruction without validating it
 *
 * @param instruction Transaction instruction to decode
 *
 * @return Decoded, non-validated instruction
 */

export function decodeInitializeMint2InstructionUnchecked(_ref) {
  var programId = _ref.programId,
      _ref$keys = _slicedToArray(_ref.keys, 1),
      mint = _ref$keys[0],
      data = _ref.data;

  var _initializeMint2Instr = initializeMint2InstructionData.decode(data),
      instruction = _initializeMint2Instr.instruction,
      decimals = _initializeMint2Instr.decimals,
      mintAuthority = _initializeMint2Instr.mintAuthority,
      freezeAuthority = _initializeMint2Instr.freezeAuthority;

  return {
    programId: programId,
    keys: {
      mint: mint
    },
    data: {
      instruction: instruction,
      decimals: decimals,
      mintAuthority: mintAuthority,
      freezeAuthority: freezeAuthority
    }
  };
}